import { useBrandingTheme } from "Store/partners/partnerHooks";
import { updateTheme } from "Store/partners/partnerSlice";
import { isDefined } from "Utils/functions";
import { getPartnerPayloadFromGrp } from "Utils/partnerUtils";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ThemeProvider } from "styled-components";

const GRP_PARAM_BRANDING_TYPE = "grp-param";

type CustomThemeProviderProps = {
  brandingType?:
    | typeof GRP_PARAM_BRANDING_TYPE
    | (string & NonNullable<unknown>);
};

export const CustomThemeProvider = ({
  brandingType = GRP_PARAM_BRANDING_TYPE,
  children,
}: React.PropsWithChildren<CustomThemeProviderProps>): React.ReactElement => {
  const theme = useBrandingTheme();
  useHandleThemeUpdate(brandingType);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

const useHandleThemeUpdate = (
  brandingType: CustomThemeProviderProps["brandingType"],
): void => {
  const dispatch = useDispatch();

  const [branding] = useState(
    brandingType === GRP_PARAM_BRANDING_TYPE
      ? new URLSearchParams(window.location.search).get("grp")
      : brandingType,
  );

  useEffect(() => {
    const partnerPayload = isDefined(branding)
      ? getPartnerPayloadFromGrp(branding)
      : null;
    if (partnerPayload) {
      dispatch(updateTheme(partnerPayload));
    }
  }, [branding]);
};
